<template>
  <v-card
    elevation="2"
    outlined
  >
    <v-toolbar
      class="primaryLight white--text"
      dense
    >
      <div>LOCALIZACIÓN DEL INCENDIO</div>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          class="pb-0"
        >
          <i>Coordenadas geográficas del punto de inicio del incendio</i>
        </v-col>
        <v-col>
          <b>Provincia:</b> {{ datos.provincia }}
        </v-col>
        <v-col>
          <b>Municipio:</b> {{ datos.municipio }}
        </v-col>
        <v-col>
          <b>Latitud:</b>
          <v-text-field
            v-model="emergencia.LATITUD"
            hide-details
            @change="$emit('actualizar-coord')"
          />
        </v-col>
        <v-col>
          <b>Longitud:</b>
          <v-text-field
            v-model="emergencia.LONGITUD"
            hide-details
            @change="$emit('actualizar-coord')"
          />
        </v-col>
        <v-col>
          <b>Hoja:</b>
          <v-text-field
            v-model="datos.hoja"
            hide-details
          />
        </v-col>
        <v-col>
          <b>Cuadrícula:</b>
          <v-text-field
            v-model="datos.cuadricula"
            hide-details
          />
        </v-col>
        <v-col>
          <b>Fecha de detección del incendio:</b> {{ fechaInicio }}
        </v-col>
        <v-col>
          <b>Hora de detección del incendio:</b> {{ horaInicio }}
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="pb-0"
        >
          <v-radio-group
            v-model="datos.granMagnitud"
            row
            label="¿Hay otros incendio de gran magnitud activos?*"
            :rules="reglas.requerido"
            hide-details
          >
            <v-radio
              label="Sí"
              value="Sí"
            />
            <v-radio
              label="No"
              value="No"
            />
          </v-radio-group>
        </v-col>
        <v-col
          cols="12"
          class="pt-0"
        >
          <v-radio-group
            v-model="datos.situacionDeclarada"
            row
            label="¿Situación operativa declarada?*"
            :rules="reglas.requerido"
            hide-details
          >
            <v-radio
              label="No existe"
              value="1"
            />
            <v-radio
              label="0"
              value="2"
            />
            <v-radio
              label="1"
              value="3"
            />
            <v-radio
              label="2"
              value="4"
            />
            <v-radio
              label="3"
              value="5"
            />
          </v-radio-group>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    value: { type: Object, required: true },
    emergencia: { type: Object, required: true },
    fechaInicio: { type: String },
    horaInicio: { type: String }
  },
  data: () => ({
    reglas: { requerido: [v => !!v || 'Campo obligatorio'] }
  }),
  computed: {
    datos: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  }
}
</script>
